import dayjs from "dayjs"
import { Anchor, Text } from "@mantine/core"
import { IconCheckBox } from "../../routes/app/-components/icon-check-box"
import { FieldDataType } from "../../orval/gen/model"
import { sanitiseHTML } from "@/utils/sanitise-html"

interface Props {
  fieldData:
    | { dataType: FieldDataType; textValue?: string | null | undefined }
    | undefined
}

export function FieldData({ fieldData }: Props) {
  if (!fieldData) return null

  const { dataType, textValue } = fieldData
  if (!textValue) return null

  switch (dataType) {
    case "Bool":
      return (
        <IconCheckBox checked={textValue === "True" || textValue === "1"} />
      )
    case "Date":
      const date = (textValue as string).split(">")[1].split("<")[0]
      return dayjs(date).format("L")
    case "Link":
      return (
        <Anchor href={textValue} target="_blank">
          {textValue}
        </Anchor>
      )
    case "TokenEdit":
      return textValue
        .replaceAll('","', ", ")
        .replaceAll('["', "")
        .replaceAll('"]', "")
    case "MultiLineText":
      return <Text style={{ whiteSpace: "pre-wrap" }}>{textValue}</Text>
    case "HtmlText":
      const sanitizedHtml = sanitiseHTML(textValue)
      return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    default:
      return textValue
  }
}
